import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Shipping Module Service Stores
 *
 * Backs the starter Shipping module at /shipping. Four small entity stores —
 * the UI is the main investment here, not analytics dashboards, so we keep
 * each config to a one-liner (no serviceViews / summary cards). Add those
 * later if the module grows.
 */
export const shippingStores: ServiceStoreConfig[] = [
  {
    name: "shipments",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "shipment-pieces",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "bills-of-lading",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "shipping-log-entries",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  // Fleet & Carriers tab on the Shipping page reads from these two. Registered
  // here (not in logistics.stores.ts) because logisticsStores is not currently
  // imported by serviceStoresConfig — moving the entries we actually need
  // ensures they get wired into rootStore. The full logistics fleet of stores
  // (load-plans, yard-storage, etc.) is intentionally NOT registered yet —
  // some of those services don't exist on the backend.
  {
    name: "delivery-trucks",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  // §1.11: `freight-carriers` bare registration removed — the accounting module now
  // registers `accounting-freight-carriers` (→ accountingFreightCarriersStore). See RootStore alias.
];
